// Schema for Florists vendor-type-specific fields.

import { FLORIST_STYLES, FLORIST_SERVICES } from '../constants/vendorOptions';
import { rentalItemsGroupFields } from './fragments/rentalItemsGroup';

export const floristsSchema = {
  vendorType: 'Florists',
  fields: [
    { key: 'floristMinPrice', type: 'price', label: 'Starting Price', optional: true },
    { key: 'floristStyles', type: 'chips', label: 'Style', options: FLORIST_STYLES, optional: true },
    { key: 'floristServices', type: 'chips', label: 'Services', options: FLORIST_SERVICES, optional: true },
    { key: 'floristOffersOtherItems', type: 'checkbox', label: 'Rental Items', displayLabel: 'Rentals' },
    ...rentalItemsGroupFields('floristOffersOtherItems'),
  ],
};